import { useState, useEffect, useRef } from 'react';

const useDelayedLoadingMessage = (delay = 5000) => {
  const [showMessage, setShowMessage] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  const startDelayedMessage = () => {
    clearTimeout(timerRef.current);
    setShowMessage(false);
    timerRef.current = setTimeout(() => {
      setShowMessage(true);
    }, delay);
  };

  const clearDelayedMessage = () => {
    clearTimeout(timerRef.current);
    setShowMessage(false);
  };

  return { showMessage, startDelayedMessage, clearDelayedMessage };
};

export default useDelayedLoadingMessage;